import React, {useEffect, useMemo, useRef, useState} from 'react';
import * as PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import notificationsActions from '../../store/actions/notificationsActions';
import balancesActions from '../../store/actions/balancesActions';
import CustomLink from '../UI/CustomLink';
import useSocket, {SOCKET_NOTIFICATIONS} from '../../customHooks/useSocket';
import helpers from '../../helpers/helpers';
import cookie from "react-cookies";
import styles from './Header.module.scss';
import Logo from '../UI/Logo/Logo';
import ThemeSwitch from './ThemeSwitch/ThemeSwitch';
import LangAndCurrency from './LangAndCurrency/LangAndCurrency';
import Search from '../NSearch/Search';
import MobileMenu from './MobileMenu/MobileMenu';
import IconProfile from '../UI/Icons/IconProfile';
import IconNotifications from '../UI/Icons/IconNotifications';
import HeaderProfile from './HeaderProfile/HeaderProfile';
import HeaderNotifications from './HeaderNotifications/HeaderNotifications';
import HeaderDropdown from './HeaderDropdown/HeaderDropdown';
import useWindowDimensions from '../../customHooks/useWindowDimensions';
import {breakpoints} from '../../constants/breakpoints';
import cls from 'classnames';
import useCloseOnBlur from '../../customHooks/useCloseOnBlur';
import {useRouter} from 'next/router';

const Header = () => {
  const [searchIsOpen, setSearchIsOpen] = useState(false);
  const searchRef = useRef(null);
  const dispatch = useDispatch();
  const {token} = useSelector((state) => state.auth);
  const {language, translations} = useSelector((state) => state.language);
  const {width} = useWindowDimensions();
  const router = useRouter();

  const {getTranslationText} = helpers;

  useSocket(SOCKET_NOTIFICATIONS);

  const handleOpenSearch = () => {
    setSearchIsOpen(true);
  };

  const handleCloseSearch = () => {
    setSearchIsOpen(false);
  };

  useEffect(() => {
    if (token) {
      dispatch(notificationsActions.getUnreadNotifications(token));
      dispatch(balancesActions.getUserBalances(token));
      dispatch(balancesActions.getTransactionHistory(token));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useCloseOnBlur(searchRef, handleCloseSearch);

  return (
    <>
      <div className={styles.header}>
        <div className={styles.headerContainer}>
          <div className={styles.headerLogoWrap}>
            <CustomLink
              href="/"
              className={styles.headerLogo}
            >
              <Logo/>
            </CustomLink>
          </div>
          <div className={styles.headerMenuLinks}>
            <a className={styles.headerMenuLink} href="https://bit.team/">BIT.TEAM</a>
            <a className={styles.headerMenuLink} href="https://bit.team/btt">TOKEN</a>
            {!!token && (
              <CustomLink href="/deposit/[id]" as="/deposit/del" className={styles.headerMenuLink}>
                {getTranslationText('general.add_nft') || 'ADD NFT'}
              </CustomLink>
            )}
          </div>
          <div className={cls(styles.headerCenter, {[styles.open]: searchIsOpen || router.route === '/search'})} ref={searchRef}>
            <Search/>
          </div>
          {translations[language] && !token && width >=breakpoints.sm && (
            <div className={styles.headerAuthButtons}>
              <a
                className={styles.headerButton}
                href={`${process.env.LOGIN_URL}`}
              >
                {getTranslationText('general.sign_in')}
              </a>
            </div>
          )}
          <div className={styles.headerRight}>
            {!!token && width >= breakpoints.lg && (
              <>
                <HeaderDropdown
                  icon={<IconNotifications/>}
                  btnClassName={styles.headerIconBtn}
                  content={(props) => <HeaderNotifications {...props}/>}
                />
                <HeaderDropdown
                  icon={<IconProfile/>}
                  btnClassName={styles.headerIconBtn}
                  content={(props) => <HeaderProfile {...props}/>}
                />
              </>
            )}
            <LangAndCurrency className={styles.headerLangAndCurrency} btnClassName={styles.headerIconBtn}/>
            <ThemeSwitch btnClassName={styles.headerIconBtn}/>
          </div>

          {width < breakpoints.lg && (
            <div className={styles.headerMobileMenu}>
              <MobileMenu onOpenSearch={handleOpenSearch}/>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

Header.propTypes = {
  toggleSidebar: PropTypes.func.isRequired,
};

export default Header;
